import React from 'react';
import s from './JobIcon.module.scss';

const VideoIcon = () => {
  return (
    <svg className={s.videoIcon} width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19_2573)">
      <path d="M36 28L24 20V36L36 28Z" stroke="white" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 29C5 35.7297 5.67881 39.6761 6.19621 41.7056C6.33303 42.2576 6.59657 42.7688 6.96518 43.197C7.33378 43.6253 7.79696 43.9585 8.31667 44.1693C15.7283 47.0785 27.9956 46.9998 27.9956 46.9998C27.9956 46.9998 40.2628 47.0785 47.6745 44.1693C48.1958 43.9597 48.6608 43.627 49.031 43.1987C49.4012 42.7703 49.6661 42.2586 49.8038 41.7056C50.3212 39.6806 51 35.7297 51 29C51 22.2703 50.3212 18.3239 49.8038 16.2944C49.6676 15.7394 49.4035 15.2254 49.0332 14.795C48.6629 14.3646 48.1971 14.0301 47.6745 13.8194C40.2628 10.9215 27.9956 11.0002 27.9956 11.0002C27.9956 11.0002 15.7283 10.9215 8.31667 13.8307C7.79404 14.0414 7.32827 14.3758 6.95798 14.8062C6.58768 15.2366 6.32352 15.7506 6.18737 16.3056C5.67881 18.3216 5 22.2703 5 29Z" stroke="white" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_19_2573">
      <rect width="57" height="57" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default VideoIcon;